import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

import {
    formatJobFormDisplayText,
    jobFormFieldText,
} from '../AI/ai-exam-onboarding-job-form.util';

/** Apparence visuelle du formulaire (sans impact sur la logique métier). */
export type JobFormNoUserAppearance = 'default' | 'onboarding';

/**
 * Champs métier + secteur liés directement à `jobForm` (job / business).
 * Aucune logique ES : uniquement le binding formulaire d'origine.
 */
@Component({
    selector: 'lib-job-form-fuse-no-user',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, TranslateModule],
    templateUrl: './job-form-fuse-no-user.component.html',
    styleUrls: ['./job-form-fuse-no-user.component.scss'],
})
export class JobFormFuseNoUserComponent implements OnInit, OnChanges {
    @Input() jobForm!: FormGroup;
    /** `onboarding` : grille et styles maquette FlashLevel. */
    @Input() appearance: JobFormNoUserAppearance = 'default';

    ngOnInit(): void {
        this.formatSelectedFieldValues();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['jobForm']) {
            this.formatSelectedFieldValues();
        }
    }

    /** Met en forme l'affichage des champs déjà sélectionnés (préremplis / désactivés). */
    private formatSelectedFieldValues(): void {
        if (!this.jobForm) {
            return;
        }

        (['job', 'business'] as const).forEach((fieldName) => {
            const control = this.jobForm.get(fieldName);
            if (!control?.disabled) {
                return;
            }

            const rawText = jobFormFieldText(control.value);
            const formatted = formatJobFormDisplayText(rawText);
            if (formatted && formatted !== rawText) {
                control.setValue(formatted, { emitEvent: false });
            }
        });
    }
}
